import axios from 'axios';
import mondaySDK from 'monday-sdk-js';
import excludeColumn from '../constants/ExcludeColumnsContants';

export default class MainService {
  private static monday = mondaySDK({
    clientId: process.env.REACT_APP_CLIENT_ID,
    apiVersion: process.env.REACT_APP_API_VERSION,
  });
  static token = '';
  static csrf = '';

  static async changeViewMode() {
    this.monday.set('settings', { viewMode: 'split' });
  }

  static async getContext() {
    this.monday.execute('valueCreatedForUser');
    let context;

    await this.monday.get('context').then(async (res) => {
      context = res?.data;
      if (!res?.data?.user?.isViewOnly) {
        const boardInfo = await this.monday.api(`{
                    boards(ids:${context?.boardId}) {
                      name
                      views {
                        id
                        name
                      }
                      owners{
                        id
                        name
                        email
                      }
                    }
                  }`);
        if (context) {
          context.boardName = boardInfo?.data?.boards?.[0]?.name;
          context.viewName = boardInfo?.data?.boards?.[0]?.views?.filter(
            (s) => s.id == context?.boardViewId
          )?.[0]?.name;
          context.owners = boardInfo?.data?.boards?.[0]?.owners;
          context.operation_link = await this.getLinkOC(context.account?.id);
        }
      }
    });

    return context;
  }

  static async getMondayUrl() {
    this.monday.execute('valueCreatedForUser');
    let url = '';
    await this.monday.get('location').then((res) => {
      url = this.getUrl(res.data);
    });

    return url;
  }

  static async getColumns(boardId) {
    const res = await this.monday.api(`{
            boards(ids: ${boardId}){
                columns{
                  id
                  title
                  type
                }}
            }`);
    return (
      res?.data?.boards?.[0]?.columns?.filter(
        (s) => !excludeColumn.includes(s.type)
      ) ?? null
    );
  }

  static async getGroup(boardId) {
    const res = await this.monday.api(`{
            boards(ids: ${boardId}){
              groups{
                id
                title
              }
            }
          }`);
    return (
      res?.data?.boards?.[0]?.groups.map((s) => {
        return {
          id: s.id,
          key: s.id,
          title: s.title,
          loadingStateType: 'medium-text',
        };
      }) ?? null
    );
  }

  static notice(message, type = 'success', timeout = 1500) {
    this.monday.execute('notice', {
      message: message,
      type: type, //or "error" (red), or "info" (blue)
      timeout: timeout,
    });
  }

  static async getGroupRequired(accountId, boardId) {
    const rs = await this.post(
      { accountId, boardId },
      'mandatory/get-required-fields-groups'
    );

    return rs;
  }

  static getUrl(data) {
    if (data?.href?.length) {
      const domainRegex = /^(?:https?:\/\/[^/]+\/boards\/\d+)/;
      const matches = data?.href.match(domainRegex);
      return matches ? matches[0] : null;
    }
    return '';
  }

  static async post(data, url) {
    try {
      const rs = await axios({
        method: 'post',
        url: `/api/${url}`,
        data: data,
        headers: {
          // 'CSRF-Token': this.csrf,
          Authorization: `Bearer ${this.token}`,
        },
      });
      return rs?.data;
    } catch (error) {
      return null;
    }
  }

  static async postLogin(data, url) {
    try {
      const rs = await axios({
        method: 'post',
        url: `/api/${url}`,
        data: data,
        headers: {
          'CSRF-Token': this.csrf,
          Authorization: `Bearer ${this.token}`,
        },
      });
      return rs?.data;
    } catch (error) {
      return null;
    }
  }

  static async get(data, url) {
    try {
      const rs = await axios({
        method: 'get',
        url: `/api/${url}`,
        data: data,
        headers: {
          'CSRF-Token': this.csrf,
        },
      });
      return rs?.data;
    } catch (error) {
      return null;
    }
  }

  static async postNoAuthen(data, url) {
    try {
      const rs = await axios({
        method: 'post',
        url: `/api/${url}`,
        data: data,
        // headers: {
        //     'CSRF-Token': this.csrf,
        // }
      });
      return rs?.data;
    } catch (error) {
      return null;
    }
  }

  static fillBoardColumn(columns) {
    if (columns?.length) {
      let tmp = columns?.map((s) => {
        return {
          key: s.id,
          id: s.id,
          title: s.title,
          loadingStateType: 'medium-text',
        };
      });
      return tmp;
    }
    return null;
  }

  static async requestResetPassword(context, resetUsers) {
    try {
      // const randomPassword = this.generateRandomPassword();
      // data.randomPassword = randomPassword;
      // const rs = await this.post(data, 'authen/reset-password');
      // if (rs?.data) {
      if (context) {
        const data = {
          accountId: context?.account?.id,
          boardId: context?.boardId,
        };
        const rs = await this.postNoAuthen(
          data,
          'authen/request-reset-password'
        );
        if (rs) {
          const text = `<strong>FieldValidator Pro app Password Reset Request</strong></br>A request has been made to reset the password for the app view in the ${context?.boardName} board. Please navigate to the FieldValidator Pro app view to approve the deactivation of the old password and set a new one.`;
          for (let i = 0; i < resetUsers.length; i++) {
            const element = resetUsers[i];
            await this.monday.api(`mutation{
                                create_notification(text: "${text}", user_id: ${element.id}, target_id: ${context?.boardId}, target_type: Project) {
                                  id
                                }
                              }`);
          }

          return rs;
        }
      }
      return false;
    } catch (error) {}
    return true;
  }

  private static generateRandomPassword(): string {
    const characters =
      'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const specialCharacters = '!@#$%^&*()_+-=[]{}|;:,.<>?';

    let password = '';

    // special charater (at least one)
    const randomSpecialChar = specialCharacters.charAt(
      Math.floor(Math.random() * specialCharacters.length)
    );
    password += randomSpecialChar;

    for (let i = 0; i < 7; i++) {
      const randomChar = characters.charAt(
        Math.floor(Math.random() * characters.length)
      );
      password += randomChar;
    }

    password = password
      .split('')
      .sort(() => Math.random() - 0.5)
      .join('');

    return password;
  }

  static async getAllAdmin() {
    const res = await this.monday.api(`{
            users{
              id
              name
              is_admin
              email
              photo_thumb
            }
          }`);

    const users = res?.data?.users;
    const allAdmin = users
      .filter((s) => s.is_admin)
      ?.map((s) => {
        return {
          value: s.id,
          label: s.name,
          name: s.name,
          leftAvatar: s.photo_thumb,
        };
      });

    return allAdmin;
  }

  static showPlan() {
    this.monday.execute('openPlanSelection', {
      isInPlanSelection: true,
      selectedPlanId: '123456',
    });
  }

  // static async postToBE(data, url) {
  //     try {
  //         const rs = await this.post(data, url);

  //         return rs?.data ?? rs;
  //     } catch (error) {
  //         return null;
  //     }
  // }

  // static async postToBENoAuthen(data, url) {
  //     try {
  //         const rs = await this.postNoAuthen(data, url);

  //         return rs?.data ?? rs;
  //     } catch (error) {
  //         return null;
  //     }
  // }

  static setToken(token) {
    if (token?.token?.length) {
      localStorage.setItem('expiresDate', token.expiresDate);
      localStorage.setItem('startDate', token.startDate);
      localStorage.setItem('autToken', token.token);
    }
    this.token = token?.token ?? '';
  }

  static getToken() {
    const expiresDate = localStorage.getItem('expiresDate');
    const startDate = localStorage.getItem('startDate');
    const token = localStorage.getItem('autToken');
    return { token, expiresDate, startDate };
  }

  static removeToken() {
    localStorage.removeItem('expiresDate');
    localStorage.removeItem('startDate');
    localStorage.removeItem('autToken');
  }

  static async getLinkOC(accountId: any) {
    try {
      const data = {
        accountId,
        appId: process.env.REACT_APP_APP_ID ?? 10141318,
      };

      const rs = await axios({
        method: 'post',
        url: `https://management.beelabxapps.com/app-validation/operation/get-link`,
        data: data,
      });

      return rs?.data?.link ?? '';
    } catch (error) {
      // console.log(error);
    }
  }
}
